<app-card-base [title]="title" [hasSubmit]="false" [hasFooter]="true">
  <ng-container main *ngTemplateOutlet="contentMain"></ng-container>
  <ng-container footer *ngTemplateOutlet="contentFooter"></ng-container>
</app-card-base>

<ng-template #contentMain>
  <div>
    <p><span class="title">Type :</span> {{ 'enum.PropertyBookletType.'+booklet.type | translate }}</p>
    <!--<p *ngIf="isRenovation">Types de travaux: {{ workTypesDisplay }}</p>-->
    <p><span class="title">Statut :</span> {{ 'enum.PropertyBookletStatus.'+booklet.status | translate }}</p>
    <p *ngIf="booklet.dateValidation">
      <span class="title">Date :</span> {{ booklet.dateValidation | dateFormat }}
    </p>
    <!--<p *ngIf="!isValidated">Progression: {{ booklet.progress }}%</p>-->
    <app-doc-summary-card *ngIf="booklet.document" [document]="booklet.document" title=""></app-doc-summary-card>
  </div>
  <div class="cil-logo">
    <img src="assets/images/logo-cil.webp" alt="CIL Logo" />
  </div>
</ng-template>

<ng-template #contentFooter>
  @if(canUpdateProperty){
  <div class="actions text-end">
    @if(!isValidated){
    <button mat-icon-button color="primary" appTooltip="Modifier" (click)="updateBooklet()"
      [disabled]="isValidating"><mat-icon>edit</mat-icon></button>
    }
    <button mat-icon-button color="primary" appTooltip="Supprimer" (click)="deleteBooklet()"
      [disabled]="isValidating"><mat-icon>delete_forever</mat-icon></button>
  </div>
  }
</ng-template>